module.exports = __webpack_public_path__ + "1642699981952/static/media/load.0bac9c78.gif";